/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import axios from "axios";
import avatarConfig from "../config/avatar.config.json";
import profileConfig from "../config/profile.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_MY_PROFILE } from "../graphql";
import { VApplication } from "../../../application";
import { capitalCase } from "change-case";

import { AppNavigatorService } from "../../appNavigatorService";

const getWhoamiSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.AppNavigatorService") as AppNavigatorService;
};

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IMyProfileCardMethods extends IPluginMethodMap {
  getMyProfile(args: any): Promise<any>;
}

export class MyProfileCardService implements IAgentPlugin {
  readonly methods: IMyProfileCardMethods;

  constructor() {
    this.methods = {
      getMyProfile: this.getMyProfile.bind(this),
    };
  }

  async getMyProfile(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.query({
          query: GET_MY_PROFILE,
          fetchPolicy: "network-only",
        });
        if (res?.data) {
          const _dataAvatar: any = await this.getFormattedAvatar(
            res.data?.getMyProfile
          );
          const _dataName: any = await this.getFormattedProfile(
            res.data?.getMyProfile
          );
          const sample = this.formatFormPropsAvatar(
            avatarConfig.TWEETY_PROPS,
            res.data?.getMyProfile
          );
          console.log("sample===>", sample);
          return {
            response: res.data?.getMyProfile,
            ...(_dataAvatar || {}),
            ...(_dataName || {}),
            all: {
              avatar: this.formatFormPropsAvatar(
                avatarConfig.TWEETY_PROPS,
                res.data?.getMyProfile
              ),
              profile: this.formatFormProps(
                profileConfig.TWEETY_PROPS,
                res.data?.getMyProfile
              ),
            },
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
    // return {...(config || {})}
  }

  private async getFormattedAvatar(data: any) {
    // console.log("getFormattedProfile line 73==>", data);
    let _profileInfo: any = {
      image: data?.image ? data?.image : "",
      initialData: {
        avatar: data?.image,
      },
    };
    return _profileInfo;
  }

  private async getFormattedProfile(data: any) {
    let _profileInfo: any = {
      title: null,
      subtitle: null,
      image: data?.image ? data?.image : "",
      description: data?.bio,
      initialData: {
        firstName: data?.firstName,
        lastName: data?.lastName,
        phoneNumber: data?.primaryContactNo,
        gender: data?.gender,
        milesCard: data?.milesCard,
        dob: data?.dob,
        address1: data?.address?.addressLine1,
        address2: data?.address?.addressLine2,
        address3: data?.address?.addressLine3,
        city: data?.address?.city,
        state: data?.address?.state,
        country: data?.address?.country,
        zipcode: data?.address?.zipcode,
      },
    };
    if (data?.firstName || data?.lastName) {
      const _first_name = data?.firstName ? capitalCase(data?.firstName) : "";
      const _last_name = data?.lastName ? capitalCase(data?.lastName) : "";
      _profileInfo.title = `${_first_name} ${_last_name}`;
    }
    // if (data?.description) {
    //   _profileInfo.subtitle = data?.description;
    // }
    _profileInfo.profileInfo?.map((item: any, index: number) => {
      console.log(item);
      if (item?.label === "Email") {
        item.value = data?.email;
      } else if (item?.label === "milesCard") {
        item.value = data?.address?.addressLine1;
      } else if (item?.label === "Address1") {
        item.value = data?.address?.addressLine1;
      } else if (item?.label === "Address2") {
        item.value = data?.address?.addressLine2;
      } else if (item?.label === "Address3") {
        item.value = data?.address?.addressLine3;
      } else if (item?.label === "city") {
        item.value = data?.address?.city;
      } else if (item?.label === "state") {
        item.value = data?.address?.state;
      } else if (item?.label === "country") {
        item.value = data?.address?.country;
      } else if (item?.label === "zipcode") {
        item.value = data?.address?.zipcode;
      } else if (item?.label === "DOB") {
        item.value = data?.dob;
      }
      return item;
    });
    return _profileInfo;
  }

  private formatFormPropsAvatar(formProps: any, data: any) {
    let _res: any = formProps;
    _res.initialData = {
      avatar: data?.image,
    };
    return _res;
  }

  private formatFormProps(formProps: any, data: any) {
    let _res: any = formProps;
    _res.initialData = {
      firstName: data?.firstName,
      lastName: data?.lastName,
      phoneNumber: data?.primaryContactNo,
      gender: data?.gender,
      milesCard: data?.milesCard,
      dob: data?.dob,
      address1: data?.address?.addressLine1,
      address2: data?.address?.addressLine2,
      address3: data?.address?.addressLine3,
      city: data?.address?.city,
      state: data?.address?.state,
      country: data?.address?.country,
      zipcode: data?.address?.zipcode,
    };

    return _res;
  }
}
